import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const ClipboardListOutline = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 16 16'
    >
      <path
        d='M12.6667 2.0013H9.88C9.6 1.22797 8.86667 0.667969 8 0.667969C7.13333 0.667969 6.4 1.22797 6.12 2.0013H3.33333C2.6 2.0013 2 2.6013 2 3.33464V12.668C2 13.4013 2.6 14.0013 3.33333 14.0013H12.6667C13.4 14.0013 14 13.4013 14 12.668V3.33464C14 2.6013 13.4 2.0013 12.6667 2.0013ZM8 2.0013C8.36667 2.0013 8.66667 2.3013 8.66667 2.66797C8.66667 3.03464 8.36667 3.33464 8 3.33464C7.63333 3.33464 7.33333 3.03464 7.33333 2.66797C7.33333 2.3013 7.63333 2.0013 8 2.0013ZM4.66667 4.66797H11.3333V3.33464H12.6667V12.668H3.33333V3.33464H4.66667V4.66797ZM8 11.3346V10.0013H11.3333V11.3346H8ZM8 7.33463V6.0013H11.3333V7.33463H8ZM5.33333 8.0013V6.0013H4.66667V5.33464H6V8.0013H5.33333ZM6.16667 9.33463C6.44 9.33463 6.66667 9.5613 6.66667 9.83463C6.66667 9.96797 6.61333 10.0946 6.52667 10.1813L5.41333 11.3346H6.66667V12.0013H4.66667V11.388L6 10.0013H4.66667V9.33463H6.16667Z'
        fill='#F8F8F8'
      />
    </SvgIcon>
  );
};
export default ClipboardListOutline;
